export default {"src":"/_next/static/media/0x2260fac5e5542a773aa44fbcfedf7c193bc2c599.684ff353.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};